import { request } from "./index";

const applyTranscription = async <T>(reqData: unknown) => {
  return request<T>({
    method: "post",
    url: "/video/applyTranscription",
    data: reqData,
  });
};

const getTranscriptionStatus = async <T>(reqData: unknown) => {
  return request<T>({
    method: "post",
    url: "/video/getTranscriptionStatus",
    data: reqData,
  });
};

export default { applyTranscription, getTranscriptionStatus };
